// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/all.css
// module id = 2016
// module chunks = 0